import { render, staticRenderFns } from "./RolesCrud.vue?vue&type=template&id=037d9488"
import script from "./RolesCrud.vue?vue&type=script&lang=js"
export * from "./RolesCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports